/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ok when refundable; otherwise no_subscription, already_refunded, period_ended (the paid period is over) or service_used (a schedule of started programmes or workouts was saved since the charge).
 * @export
 */
export const V1StarsSubscriptionRefundReason = {
    Ok: 'ok',
    NoSubscription: 'no_subscription',
    AlreadyRefunded: 'already_refunded',
    ServiceUsed: 'service_used',
    PeriodEnded: 'period_ended'
} as const
export type V1StarsSubscriptionRefundReason =
    (typeof V1StarsSubscriptionRefundReason)[keyof typeof V1StarsSubscriptionRefundReason]

export function instanceOfV1StarsSubscriptionRefundReason(value: any): boolean {
    for (const key in V1StarsSubscriptionRefundReason) {
        if (
            Object.prototype.hasOwnProperty.call(
                V1StarsSubscriptionRefundReason,
                key
            )
        ) {
            if (
                V1StarsSubscriptionRefundReason[
                    key as keyof typeof V1StarsSubscriptionRefundReason
                ] === value
            ) {
                return true
            }
        }
    }
    return false
}

export function V1StarsSubscriptionRefundReasonFromJSON(
    json: any
): V1StarsSubscriptionRefundReason {
    return V1StarsSubscriptionRefundReasonFromJSONTyped(json, false)
}

export function V1StarsSubscriptionRefundReasonFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1StarsSubscriptionRefundReason {
    return json as V1StarsSubscriptionRefundReason
}

export function V1StarsSubscriptionRefundReasonToJSON(
    value?: V1StarsSubscriptionRefundReason | null
): any {
    return value as any
}

export function V1StarsSubscriptionRefundReasonToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1StarsSubscriptionRefundReason {
    return value as V1StarsSubscriptionRefundReason
}
